import {
  GET_USER_WALLET,
  GET_USER_WALLET_SUCCESS,
  GET_USER_WALLET_FAILURE,
  CREATE_FUNDING_INTENT,
  CREATE_FUNDING_INTENT_SUCCESS,
  CREATE_FUNDING_INTENT_FAILURE,
  INITIALIZE_FUNDING_PAYMENT,
  INITIALIZE_FUNDING_PAYMENT_SUCCESS,
  INITIALIZE_FUNDING_PAYMENT_FAILURE,
  VERIFY_FUNDING_PAYMENT,
  VERIFY_FUNDING_PAYMENT_SUCCESS,
  VERIFY_FUNDING_PAYMENT_FAILURE,
  GET_WALLET_HISTORY,
  GET_WALLET_HISTORY_SUCCESS,
  GET_WALLET_HISTORY_FAILURE,
} from "../ActionTypes";

export const getUserWallet = (id) => ({
  type: GET_USER_WALLET,
  payload: id,
});

export const getUserWalletSuccess = (payload) => ({
  type: GET_USER_WALLET_SUCCESS,
  payload,
});

export const getUserWalletFailure = (payload) => ({
  type: GET_USER_WALLET_FAILURE,
  payload,
});

// 1. Create Funding Intent
export const createFundingIntent = (payload) => ({
  type: CREATE_FUNDING_INTENT,
  payload,
});
export const createFundingIntentSuccess = (payload) => ({
  type: CREATE_FUNDING_INTENT_SUCCESS,
  payload,
});
export const createFundingIntentFailure = (payload) => ({
  type: CREATE_FUNDING_INTENT_FAILURE,
  payload,
});

// 2. Initialize Payment (Get Paystack URL)
export const initializeFundingPayment = (payload) => ({
  type: INITIALIZE_FUNDING_PAYMENT,
  payload,
});
export const initializeFundingPaymentSuccess = (payload) => ({
  type: INITIALIZE_FUNDING_PAYMENT_SUCCESS,
  payload,
});
export const initializeFundingPaymentFailure = (payload) => ({
  type: INITIALIZE_FUNDING_PAYMENT_FAILURE,
  payload,
});

// 3. Verify Payment
export const verifyFundingPayment = (payload) => ({
  type: VERIFY_FUNDING_PAYMENT,
  payload,
});
export const verifyFundingPaymentSuccess = (payload) => ({
  type: VERIFY_FUNDING_PAYMENT_SUCCESS,
  payload,
});
export const verifyFundingPaymentFailure = (payload) => ({
  type: VERIFY_FUNDING_PAYMENT_FAILURE,
  payload,
});

export const getWalletHistory = (payload) => ({
  type: GET_WALLET_HISTORY,
  payload, // payload can contain { wallet_id, page, search, etc. }
});

export const getWalletHistorySuccess = (payload) => ({
  type: GET_WALLET_HISTORY_SUCCESS,
  payload,
});

export const getWalletHistoryFailure = (payload) => ({
  type: GET_WALLET_HISTORY_FAILURE,
  payload,
});
